import TYPES from './types';
import CartService, { ICartServiceItem } from 'src/services/cart/CartService';
import { ICartError, ICartSuccess } from './reducers';
import CartItemModel from 'src/model/cartItem.model';
import LocationModel from 'src/model/location.model';
import OneTimeAddressModel from 'src/model/oneTimeAddress.model';
import i18n from 'src/translation/i18n';
import { downloadFile } from 'src/utils/downloadHelper';
import { analyticsActions } from 'src/analytics/store';
import env from 'src/shared/env';
const setIsPending = (isPending: boolean) => {
  return {
    type: TYPES.SET_IS_PENDING,
    payload: isPending ? isPending : false
  };
};

const setIsPendingLists = (isPendingList: boolean) => {
  return {
    type: TYPES.SET_IS_PENDING_LISTS,
    payload: isPendingList ? isPendingList : false
  };
};

const setFileUploadStatus = (isFileStatus: boolean) => {
  return {
    type: TYPES.SET_IS_PENDING_LISTS,
    payload: isFileStatus ? isFileStatus : false
  };
};

const setUpdating = (updating: boolean) => {
  return {
    type: TYPES.SET_UPDATING,
    payload: updating ? updating : false
  };
};

const setError = (error?: ICartError) => {
  return {
    type: TYPES.SET_ERROR,
    payload: error
      ? error
      : {
          hasFailed: false,
          message: ''
        }
  };
};

const setSuccess = (succed?: ICartSuccess) => {
  return {
    type: TYPES.SET_SUCCESS_CART,
    payload: succed
      ? succed
      : {
          hasSucced: false,
          message: ''
        }
  };
};

const setDeliverMethod = (deliverMethod: string) => {
  return {
    type: TYPES.SET_DELIVER_METHOD,
    payload: deliverMethod ? deliverMethod : 'Shipping'
  };
};

const setDeliverTo = (deliverTo: LocationModel) => {
  return {
    type: TYPES.SET_DELIVER_TO,
    payload: deliverTo ? deliverTo : null
  };
};

const setDeliveryLocationCode = (deliveryLocationCode: string) => {
  return {
    type: TYPES.SET_DELIVERY_LOCATION_CODE,
    payload: deliveryLocationCode ? deliveryLocationCode : null
  };
};
const setSuppliedFromCode = (suppliedFromCode: string) => {
  return {
    type: TYPES.SET_SUPPLIED_FROM_CODE,
    payload: suppliedFromCode ? suppliedFromCode : 'Shipping'
  };
};

const setSubtotal = (subtotal: string) => {
  return {
    type: TYPES.SET_SUBTOTAL,
    payload: subtotal ? subtotal : '0'
  };
};

const setItemsCount = (itemsCount: number) => {
  return {
    type: TYPES.SET_ITEMS_COUNT,
    payload: itemsCount ? itemsCount : 0
  };
};

const removeItem = (itemID: number) => {
  return {
    type: TYPES.ITEM_REMOVE,
    payload: itemID
  };
};

const clearItems = () => {
  return {
    type: TYPES.CLEAR_ALL
  };
};

const appendItem = (item: CartItemModel) => {
  return {
    type: TYPES.ADD_ITEM,
    payload: item
  };
};

const setCartIsDownloadingPdf = (isDownloadingPdf: boolean) => {
  return {
    type: TYPES.SET_CART_IS_DOWNLOADING_PDF,
    payload: isDownloadingPdf
  };
};

export const getItemCount = () => {
  return (dispatch: any) => {
    dispatch(setError());
    dispatch(
      setSuccess({
        hasSucced: false,
        message: ''
      })
    );
    CartService.getCartItemsCount()
      .then((response: number) => {
        dispatch(setItemsCount(response));
      })
      .catch(error => {
        dispatch(
          setError({
            hasFailed: true,
            message:
              'Error fetching item count. ' +
              (error.response ? error.response.message : error)
          })
        );
        console.error('ERROR', error);
      });
  };
};

const getBasicInfo = () => {
  return (dispatch: any) => {
    dispatch(setError());
    dispatch(
      setSuccess({
        hasSucced: false,
        message: ''
      })
    );
    CartService.getCartBasicInfo()
      .then(response => {
        dispatch(setDeliverMethod(response.delivery));
        // dispatch(setItemsCount(response.itemCount));
        // dispatch(setSubtotal(response.subTotal));
        // dispatch(clearItems());
        dispatch(setDeliverTo(response.deliveryLocation));
        dispatch(setDeliveryLocationCode(response.deliveryLocationCode));
        // dispatch(setSuppliedFromCode(response.suppliedFromCode));
        // for (const key in response.items) {
        //   if (response.items.hasOwnProperty(key)) {
        //     dispatch(appendItem(response.items[key]));
        //   }
        // }
        dispatch(setIsPending(false));
      })
      .catch(error => {
        dispatch(
          setError({
            hasFailed: true,
            message:
              'Error fetching item count. ' +
              (error.response ? error.response.message : error)
          })
        );
        console.error('ERROR', error);
      });
  };
};

const addItems = (items: ICartServiceItem[], onFinish?: () => void) => {
  return (dispatch: any) => {
    // Call to API to add the items
    dispatch(setIsPending(true));
    dispatch(setError());
    dispatch(
      setSuccess({
        hasSucced: false,
        message: ''
      })
    );
    CartService.addItems(items)
      .then(response => {
        response.forEach(item => dispatch(appendItem(item)));
        dispatch(setIsPending(false));
        dispatch(getInfo());
        if (onFinish) {
          onFinish();
        }
        dispatch(
          setSuccess({
            hasSucced: true,
            message: 'Items are added to cart.'
          })
        );
      })
      .catch(error => {
        dispatch(setIsPending(false));
        dispatch(
          setError({
            hasFailed: true,
            message:
              'Error adding item. ' +
              (error.response ? error.response.message : error)
          })
        );
        console.error('ERROR', error);
      });
  };
};

const addItemsFromList = (items: ICartServiceItem[], onFinish?: () => void) => {
  return (dispatch: any) => {
    // Call to API to add the items
    dispatch(setIsPending(true));
    dispatch(setError());
    dispatch(
      setSuccess({
        hasSucced: false,
        message: ''
      })
    );
    CartService.addItems(items)
      .then(response => {
        response.forEach(item => dispatch(appendItem(item)));
        dispatch(setIsPending(false));
        dispatch(getItemCount());
        if (onFinish) {
          onFinish();
        }
        dispatch(
          setSuccess({
            hasSucced: true,
            message: 'All items from list are added to cart.'
          })
        );
        dispatch(
          analyticsActions.productAddListToCartFromFavoritesPage(response)
        );
      })
      .catch(error => {
        dispatch(setIsPending(false));
        dispatch(
          setError({
            hasFailed: true,
            message:
              'Error adding item. ' +
              (error.response ? error.response.message : error)
          })
        );
        console.error('ERROR', error);
      });
  };
};

const addItem = (
  claims: string,
  delivery: string,
  deliveryLocation: string,
  oneTimeAddress: OneTimeAddressModel,
  partNumber: string,
  quantity: number,
  rushOrder: boolean,
  shipmentMarking: string,
  shipsfrom: string,
  ticketNumber: string,
  warrantyProvider: string
) => {
  return (dispatch: any) => {
    // Call to API to add the item
    dispatch(setIsPending(true));
    dispatch(setError());
    dispatch(
      setSuccess({
        hasSucced: false,
        message: ''
      })
    );
    CartService.addItem(
      claims,
      delivery,
      deliveryLocation,
      oneTimeAddress,
      partNumber,
      quantity,
      rushOrder,
      shipmentMarking,
      shipsfrom,
      ticketNumber,
      warrantyProvider
    )
      .then(response => {
        dispatch(appendItem(response));
        dispatch(setIsPending(false));
        dispatch(getInfo());
        dispatch(
          setSuccess({
            hasSucced: true,
            message: 'Item from list is added to cart.'
          })
        );
      })
      .catch(error => {
        let data: string[] = null;

        if (error.response) {
          data = error.response.data.split('-');
        } else {
          data = error;
        }
        dispatch(setIsPending(false));
        dispatch(
          setError({
            hasFailed: true,
            message: 'Error adding item. ' + data
          })
        );
        console.error('ERROR', error);
      });
  };
};

const addItemFromList = (
  claims: string,
  delivery: string,
  deliveryLocation: string,
  oneTimeAddress: OneTimeAddressModel,
  partNumber: string,
  quantity: number,
  rushOrder: boolean,
  shipmentMarking: string,
  shipsfrom: string,
  ticketNumber: string,
  warrantyProvider: string
) => {
  return (dispatch: any) => {
    // Call to API to add the item
    dispatch(setIsPending(true));
    dispatch(setError());
    dispatch(
      setSuccess({
        hasSucced: false,
        message: ''
      })
    );
    CartService.addItem(
      claims,
      delivery,
      deliveryLocation,
      oneTimeAddress,
      partNumber,
      quantity,
      rushOrder,
      shipmentMarking,
      shipsfrom,
      ticketNumber,
      warrantyProvider
    )
      .then(response => {
        dispatch(appendItem(response));
        dispatch(setIsPending(false));
        dispatch(getItemCount());
        dispatch(
          setSuccess({
            hasSucced: true,
            message: 'Item from list is added to cart.'
          })
        );
        const product = {
          productNumber: partNumber,
          quantity,
          manufacturer: response.manufacturer,
          price: response.unitPrice,
          itemId: response.id
        };
        dispatch(analyticsActions.productAddToCartFromFavoritesPage(product));
      })
      .catch(error => {
        let data: string[] = null;

        if (error.response) {
          data = error.response.data.split('-');
        } else {
          data = error;
        }
        dispatch(setIsPending(false));
        dispatch(
          setError({
            hasFailed: true,
            message: 'Error adding item. ' + data
          })
        );
        console.error('ERROR', error);
      });
  };
};

const addSimpleItem = (partNumber: string, quantity: number) => {
  return (dispatch: any) => {
    // Call to API to add the item
    dispatch(setIsPending(true));
    dispatch(setError());
    dispatch(
      setSuccess({
        hasSucced: false,
        message: ''
      })
    );
    CartService.addItemSimple(partNumber, quantity)
      .then(response => {
        dispatch(appendItem(response));
        dispatch(setIsPending(false));
        dispatch(getInfo());
        dispatch(
          setSuccess({
            hasSucced: true,
            message: 'Item from list is added to cart.'
          })
        );
        const product = {
          productNumber: partNumber,
          quantity,
          manufacturer: response.manufacturer,
          price: response.unitPrice,
          itemId: response.id
        };
        dispatch(analyticsActions.productAddSimpleToCart(product));
      })
      .catch(error => {
        dispatch(setIsPending(false));
        dispatch(
          setError({
            hasFailed: true,
            message:
              'Error adding item. ' +
              (
                error.response
                  ? error.response.data === 'Product Price issue'
                    ? i18n.t('common.itemErrorTocartTxt')
                    : error.response.data
                  : error
              )
          })
        );
        console.error('ERROR', error);
      });
  };
};

const updateItem = (
  claims: string,
  id: number,
  quantity: number,
  shipmentMarking: string,
  shipsfrom: string,
  warrantyProvider: string,
  rushOrder: boolean,
  ticketNumber: string,
  isRefresh: boolean
) => {
  return (dispatch: any) => {
    // Call to API to update the item
    dispatch(setUpdating(true));
    dispatch(setError());
    dispatch(
      setSuccess({
        hasSucced: false,
        message: ''
      })
    );
    CartService.updateItem(
      claims,
      id,
      quantity,
      shipmentMarking,
      shipsfrom,
      warrantyProvider,
      rushOrder,
      ticketNumber
    )
      .then(response => {
        dispatch(setUpdating(false));
        if (isRefresh) {
          dispatch(reload());
        }
      })
      .catch(error => {
        dispatch(setUpdating(false));
        dispatch(
          setError({
            hasFailed: true,
            message:
              'Error updating item. ' +
              (error.response ? error.response.data : error)
          })
        );
        console.error('ERROR', error);
      });
  };
};

const deleteItem = (itemId: number) => {
  return (dispatch: any) => {
    // Call to API to add the item
    dispatch(setUpdating(true));
    dispatch(setError());
    dispatch(
      setSuccess({
        hasSucced: false,
        message: ''
      })
    );
    CartService.deleteItem(itemId)
      .then(response => {
        dispatch(setUpdating(false));
        dispatch(reload());
      })
      .catch(error => {
        dispatch(setUpdating(false));
        dispatch(
          setError({
            hasFailed: true,
            message: 'Error deleting item'
          })
        );
        console.error('ERROR', error);
      });
  };
};

const getInfo = () => {
  return (dispatch: any) => {
    dispatch(setIsPending(true));
    dispatch(setError());
    dispatch(
      setSuccess({
        hasSucced: false,
        message: ''
      })
    );
    CartService.getCart()
      .then(response => {
        dispatch(setDeliverMethod(response.delivery));
        dispatch(setItemsCount(response.itemCount));
        dispatch(setSubtotal(response.subTotal));
        dispatch(clearItems());
        dispatch(setDeliverTo(response.deliveryLocation));
        dispatch(setDeliveryLocationCode(response.deliveryLocationCode));
        dispatch(setSuppliedFromCode(response.suppliedFromCode));
        for (const key in response.items) {
          if (response.items.hasOwnProperty(key)) {
            dispatch(appendItem(response.items[key]));
          }
        }
        dispatch(setIsPending(false));
        dispatch(analyticsActions.getItemsInCartInfo(response));
      })
      .catch(error => {
        dispatch(setIsPending(false));
        dispatch(
          setError({
            hasFailed: true,
            message: `${i18n.t('common.errorGettingCartInfo')}`
          })
        );
        console.error('ERROR', error);
      });
  };
};

const reload = () => {
  return (dispatch: any) => {
    dispatch(setUpdating(true));
    dispatch(setError());
    dispatch(
      setSuccess({
        hasSucced: false,
        message: ''
      })
    );
    CartService.getCart()
      .then(response => {
        dispatch(setUpdating(false));
        dispatch(setDeliverMethod(response.delivery));
        dispatch(setItemsCount(response.itemCount));
        dispatch(setSubtotal(response.subTotal));
        dispatch(clearItems());
        dispatch(setDeliverTo(response.deliveryLocation));
        dispatch(setDeliveryLocationCode(response.deliveryLocationCode));
        dispatch(setSuppliedFromCode(response.suppliedFromCode));
        for (const key in response.items) {
          if (response.items.hasOwnProperty(key)) {
            dispatch(appendItem(response.items[key]));
          }
        }
        dispatch(analyticsActions.getItemsInCartInfo(response));
      })
      .catch(error => {
        dispatch(setUpdating(false));
        dispatch(
          setError({
            hasFailed: true,
            message: `${i18n.t('common.errorGettingCartInfo')}`
          })
        );
        console.error('ERROR', error);
      });
  };
};

const clearCart = () => {
  return (dispatch: any) => {
    dispatch(setIsPending(true));
    dispatch(setError());
    dispatch(
      setSuccess({
        hasSucced: false,
        message: ''
      })
    );
    CartService.clearCart()
      .then(response => {
        dispatch(getInfo());
        dispatch(analyticsActions.clearAllItemsFromCart());
      })
      .catch(error => {
        dispatch(setIsPending(false));
        dispatch(
          setError({
            hasFailed: true,
            message: 'Error clearing cart'
          })
        );
        console.error('ERROR', error);
      });
  };
};

const uploadItemsFromFile = (file: FormData) => {
  return (dispatch: any) => {
    dispatch(setIsPending(true));
    dispatch(setError());
    dispatch(
      setSuccess({
        hasSucced: false,
        message: ''
      })
    );
    CartService.uploadFile(file)
      .then(response => {
        dispatch(setIsPending(false));
        dispatch(getInfo());
        response.data.forEach((item: any) => {
          dispatch(analyticsActions.productUploadFileAddToCart(item));
        });
        dispatch(setFileUploadStatus(false));
      })
      .catch(error => {
        const data = error.response.data.message;
        let errorString = '';
        let finalString = '';
        const cartUploadLineError = `${i18n.t('common.cartUploadLineError')}`;
        if (
          error.response.data.status === 500 ||
          error.response.data.status === 504 ||
          error.response.data.status === 404
        ) {
          finalString = `${i18n.t('common.fileUploadError')}`;
          dispatch(setIsPendingLists(false));
          dispatch(
            setError({
              hasFailed: true,
              message: finalString
            })
          );
        } else {
          if (data === 'invalidProperty') {
            finalString =
              env.REACT_APP_BASE_ENVIRONMENT === 'US'
                ? `${i18n.t('common.invalidProperty')}`
                : `${i18n.t('common.invalidPropertyca')}`;
          } else {
            const dataRows = data.split('-');
            dataRows.forEach((row: any) => {
              const datarowsSpilt = row.split(': ');
              const lineNumber = datarowsSpilt[0];
              const errorMessages = datarowsSpilt[1].split(',');

              let errorMsg;
              const rowNum = datarowsSpilt[0].split(',');

              if (errorMessages.length > 1) {
                for (const [index, value] of Object.entries(errorMessages)) {
                  const errormsges =
                    value === 'invalidMfcPartCombination'
                      ? ' ' + `${i18n.t('common.invalidMfcPartCombination')}`
                      : value === 'invalidName'
                      ? ' ' + `${i18n.t('common.invalidpartnum')}`
                      : value === 'nameEmpty'
                      ? ' ' + `${i18n.t('common.missingpartnum')}`
                      : value === 'mfcMissing'
                      ? ' ' + `${i18n.t('common.missingmfc')}`
                      : value === 'invalidQuantity'
                      ? ' ' + `${i18n.t('common.invqunty')}`
                      : value === 'quantityEmpty'
                      ? ' ' + `${i18n.t('common.missingqnty')}`
                      : value === 'NLAPart'
                      ? ' ' + `${i18n.t('common.NLAPart')}`
                      : ' ' + value;

                  errorMessages[index] = errormsges;
                  errorMsg = errorMessages;
                }
              } else {
                errorMsg =
                  errorMessages[0] === 'invalidName'
                    ? ' ' + `${i18n.t('common.invalidpartnum')}`
                    : errorMessages[0] === 'nameEmpty'
                    ? ' ' + `${i18n.t('common.missingpartnum')}`
                    : errorMessages[0] === 'NLAPart'
                    ? ' ' + `${i18n.t('common.NLAPart')}`
                    : errorMessages[0] === 'invalidQuantity'
                    ? ' ' + `${i18n.t('common.invqunty')}`
                    : errorMessages[0] === 'invalidMfcPartCombination'
                    ? ' ' + `${i18n.t('common.invalidMfcPartCombination')}`
                    : errorMessages[0] === 'quantityEmpty'
                    ? ' ' + `${i18n.t('common.missingqnty')}`
                    : errorMessages[0] === 'mfcMissing'
                    ? ' ' + `${i18n.t('common.missingmfc')}`
                    : ' ' + errorMessages[0];
              }

              errorString +=
                `${i18n.t('common.errorLine')}` +
                ' ' +
                rowNum +
                ':' +
                ' ' +
                errorMsg;
              // errorString += `${i18n.t('common.errorLine')}` + ' ' +row;

              errorMessages.forEach((errormsg: any, index: any) => {
                if (index === errorMessages.length - 1) {
                  errorString += '\n';
                }
                // else {
                //   errorString += ', ';
                // }
              });
            });
            finalString = cartUploadLineError + '\n' + errorString;
          }
        }

        dispatch(setIsPending(false));
        dispatch(
          setError({
            hasFailed: true,
            message: finalString
          })
        );
        console.error('ERROR', error);
      });
  };
};

const switchDeliverMethod = (
  delivery: string,
  deliveryLocation: string,
  oneTimeAddress: OneTimeAddressModel | null
) => {
  return (dispatch: any) => {
    dispatch(setIsPending(true));
    dispatch(setError());
    dispatch(
      setSuccess({
        hasSucced: false,
        message: ''
      })
    );
    CartService.switchDeliverMethod(delivery, deliveryLocation, oneTimeAddress)
      .then(response => {
        dispatch(setIsPending(false));
        dispatch(reload());
      })
      .catch(error => {
        dispatch(setIsPending(false));
        dispatch(
          setError({
            hasFailed: true,
            message: error.response ? error.response.data : error
          })
        );
      });
  };
};

const switchShipFrom = (deliveryLocation: string) => {
  return (dispatch: any) => {
    dispatch(setIsPending(true));
    dispatch(setError());
    dispatch(
      setSuccess({
        hasSucced: false,
        message: ''
      })
    );
    CartService.switchShipFrom(deliveryLocation)
      .then(response => {
        dispatch(setIsPending(false));
        dispatch(reload());
      })
      .catch(error => {
        dispatch(setIsPending(false));
        dispatch(
          setError({
            hasFailed: true,
            message:
              'Cannot change ship from address. ' +
              (error.response ? error.response.data : '')
          })
        );
        console.error('ERROR', error);
      });
  };
};

const downloadOrderPdf = (orderString: string) => (dispatch: any) => {
  dispatch(setCartIsDownloadingPdf(true));

  CartService.generateOrderPDF(orderString)
    .then(pdf => {
      downloadFile(pdf, `Order confirmation.pdf`);
      dispatch(setCartIsDownloadingPdf(false));
    })
    .catch(() => {
      dispatch(
        setError({
          hasFailed: true,
          message: 'pdf is not available'
        })
      );
      dispatch(setCartIsDownloadingPdf(false));
    });
};

export default {
  setDeliverMethod,
  setDeliverTo,
  setSubtotal,
  setItemsCount,
  removeItem,
  clearItems,
  addSimpleItem,
  addItem,
  addItemFromList,
  addItems,
  addItemsFromList,
  getItemCount,
  setError,
  setIsPending,
  getInfo,
  reload,
  clearCart,
  uploadItemsFromFile,
  switchDeliverMethod,
  switchShipFrom,
  updateItem,
  deleteItem,
  setSuccess,
  getBasicInfo,
  setCartIsDownloadingPdf,
  downloadOrderPdf
};
